// Mock project data
export const projectsData = [
  {
    id: 'kewats-legacy',
    name: "Kewat's Legacy",
    tagline: 'Where Luxury Meets Nature',
    location: 'Khopoli, Maharashtra',
    type: 'Plotted Development',
    status: 'Available',
    pricing: {
      from: '₹65 Lakhs',
      original: '₹70 Lakhs'
    },
    size: '20,000 sq.ft plots',
    image: 'https://images.unsplash.com/photo-1705897141281-88daf3380a3a',
    featured: true,
    highlights: [
      '40 mins from NMIA',
      "India's #1 Investment Hotspot (Colliers rated)",
      '3.9X growth by 2030',
      'Grade-A agricultural land with clear titles',
      'Part of NAINA Smart City (₹3 lakh crore investment)',
      'Strategic mid-point between Mumbai and Pune'
    ],
    description: 'Premium plotted development in Khopoli - India\'s #1 rated investment hotspot by Colliers. A once-in-a-lifetime opportunity at the heart of Mumbai 3.0\'s growth story.'
  },
  {
    id: 'goaa-premium-residences',
    name: 'G.O.A.A. Premium Residences',
    tagline: "Goa's 5-Star Life. For a Lifetime.",
    location: 'Bicholim, North Goa',
    type: '1 BHK Serviced Residences',
    status: 'Limited Edition',
    pricing: {
      from: '₹83.70 Lakhs',
      note: 'All-inclusive'
    },
    size: '1 BHK with large sundecks',
    image: 'https://images.unsplash.com/photo-1537996194471-e657df975ab4',
    featured: true,
    highlights: [
      'Serviced by Miros Hotels & Resorts',
      "India's largest man-made sea & beach",
      '40,000 sq.ft clubhouse - Goa\'s largest',
      '5-star hospitality and amenities',
      'Panoramic views of lush forests',
      'Lifetime access to One Goa clubhouse',
      'RERA: PRGO01262613'
    ],
    description: 'Limited-edition 1 BHK serviced residences in the heart of North Goa, set beside India\'s largest man-made sea. Each home is designed for a life of pure indulgence with 5-star precision.'
  },
  {
    id: 'one-goa',
    name: 'One Goa',
    tagline: "The Vibe™ - Goa's First 130+ Acre Carbon Negative Development",
    location: 'Bicholim, Goa',
    type: 'Villa Land',
    status: 'Available',
    pricing: {
      from: 'Starting ₹45 Lakhs',
      note: "India's largest land launch in Goa"
    },
    size: '1,537 sq.ft & 1,849 sq.ft plots',
    image: 'https://images.unsplash.com/photo-1559827260-dc66d52bef19',
    featured: true,
    highlights: [
      'Goa\'s first and only 130+ acre carbon negative development',
      '5-star branded land development',
      'One of Top 15 global travel destinations',
      '1.16 crore passengers per annum at airport',
      '139% rise in foreign tourist arrivals',
      '₹5,400 crore state infrastructure investment',
      '35% of HNIs plan to invest in Goa real estate'
    ],
    description: 'India\'s largest land launch in Goa - a 130+ acre carbon negative, 5-star branded land development. Rare limited supply in India\'s most-loved luxury destination.'
  },
  {
    id: 'gulf-of-goa-villas',
    name: 'Gulf of Goa Estate Villas',
    tagline: 'Your Goan Shoreline Address',
    location: 'Central Goa (7 mins from Dabolim Airport)',
    type: 'Private Pool Villas',
    status: 'Pre-Launch',
    pricing: {
      from: 'On Request',
      note: 'Exclusive collection'
    },
    size: '18 fully-serviced private pool villas',
    image: 'https://images.unsplash.com/photo-1613490493576-7fde63acd811',
    featured: true,
    highlights: [
      "Goa's only shoreline 5-star branded land development",
      'Curated by world-renowned architect Sanjay Puri',
      '1.5 lakh+ sq.ft of recreational spaces',
      'Serviced by Miros Hotels & Resorts',
      'Avoid Goa\'s complex land laws',
      '7 minutes from Dabolim International Airport',
      '10-15% rental yields'
    ],
    description: 'A rare collection of 18 fully-serviced private-pool villas inside Goa\'s only shoreline 5-star branded land development. Seamless ownership, zero hassle.'
  },
  {
    id: 'isle-of-anjarle',
    name: 'Isle of Anjarle',
    tagline: "The World's Rarest Sea × Hill Address",
    location: 'Anjarle, Konkan Coast',
    type: 'Sea-facing Plots & Villas',
    status: 'Available',
    pricing: {
      from: 'Starting ₹45 Lakhs',
      note: 'Limited inventory'
    },
    size: 'Plots & villa options',
    image: 'https://images.unsplash.com/photo-1559827260-dc66d52bef19',
    featured: false,
    highlights: [
      '0.1% phenomenon - Sea × Hill combination',
      '76% beachfront super-multiplier',
      'First 5-star development in Anjarle',
      'Protected by strict CRZ norms',
      'In-premise clubhouse and resort',
      'Konkan Marine Expressway connectivity',
      'MAHARERA: P52800050210 (multiple phases)'
    ],
    description: 'The world\'s rarest sea × hill address where the mountain descends into the ocean. A geological miracle that will never happen again - protected by CRZ regulations.'
  },
  {
    id: 'aero-estate',
    name: 'Aero Estate',
    tagline: 'Where Life Takes Off',
    location: 'Near NMIA, Navi Mumbai (40 mins from NMIA)',
    type: 'Plotted Development',
    status: 'Available',
    pricing: {
      from: 'Starting ₹55 Lakhs',
      note: 'Grade-A MMR land'
    },
    size: 'Premium plots',
    image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c',
    featured: true,
    highlights: [
      'Just inaugurated: Navi Mumbai International Airport (Oct 8, 2025)',
      'NMIA handles 9 crore passengers annually',
      'Proximity to NAINA - 90,000-acre smart city (₹2.1 lakh crore investment)',
      '₹50,000 crore data centre investments by Google, Microsoft',
      'Grade-A MMR land at unmatched entry price',
      'Airport-led exponential growth across MMR',
      'India\'s new global gateway'
    ],
    description: 'Catch the once-in-a-lifetime opportunity at Aero Estate. Harness airport-led growth with NMIA\'s inauguration marking the dawn of Mumbai 3.0 - a global gateway driving exponential growth.'
  },
  {
    id: 'nagpur-opportunity-window',
    name: "Nagpur's Opportunity Window (N.O.W.)",
    tagline: "India's #1 Emerging City - The Growth Story India is Backing",
    location: 'Nagpur, Maharashtra',
    type: 'Plotted Development',
    status: 'Pre-Launch',
    pricing: {
      from: 'Coming Soon',
      note: 'RERA registration in process'
    },
    size: 'Residential plots',
    image: 'https://images.unsplash.com/photo-1582407947304-fd86f028f716',
    featured: true,
    highlights: [
      "Ranked #1 emerging city by Colliers International 2025",
      '₹4.5 lakh crore investment-led transformation',
      'Outperformed 30 other tier-2 cities in India',
      'Maharashtra\'s ₹1 trillion state economy vision anchor',
      'Physical infrastructure, social infra, demographics, economic growth',
      'Government commitment, connectivity surge, industrial expansion',
      'This is the decade - from foundation to take-off'
    ],
    description: 'Nagpur has officially outperformed 30 other emerging Indian tier-2 cities to be ranked #1 by Colliers. A ₹4.5 lakh crore transformation creating India\'s next growth engine beyond Mumbai and Pune.'
  },
  {
    id: 'sez-vrindavan',
    name: 'S.E.Z. Vrindavan (The Raas)',
    tagline: "World's No.1 Spiritual Economic Zone",
    location: 'Vrindavan, Uttar Pradesh',
    type: 'Spiritual Residential Plots',
    status: 'Available',
    pricing: {
      from: 'Starting ₹35 Lakhs',
      note: 'RERA: UPRERAPRJ137423/11/2025'
    },
    size: 'Residential plots near spiritual hub',
    image: 'https://images.unsplash.com/photo-1564507592333-c60657eea523',
    featured: false,
    highlights: [
      'World\'s No.1 Spiritual Economic Zone',
      'Faith-based economy - belief compounds across generations',
      'Permanent footfall from pilgrims worldwide',
      'Generational wealth opportunity',
      'India - world\'s largest spiritual economy',
      'Inspired by Vatican City, Kathmandu, Mecca models',
      'UP RERA registered: UPRERAPRJ137423/11/2025'
    ],
    description: 'A spiritual economy operates on belief, not cycles. Vrindavan represents a once-in-a-lifetime opportunity in the world\'s largest spiritual economy, where faith creates permanent footfall and generational wealth.'
  },
  {
    id: 'chateau-de-alibaug',
    name: 'Chateau de Alibaug',
    tagline: 'French Riviera Inspired Coastal Living',
    location: 'Alibaug, Maharashtra',
    type: 'Villa Plots',
    status: 'Coming Soon',
    pricing: {
      from: 'On Request',
      note: 'Premium French-inspired development'
    },
    size: 'Luxury villa plots',
    image: 'https://images.unsplash.com/photo-1580587771525-78b9dba3b914',
    featured: false,
    highlights: [
      'French Riviera-inspired architecture',
      'Prime coastal location in Alibaug',
      'Close to Mumbai via ferry and road',
      'Luxury villa plot development',
      'Premium weekend getaway destination',
      'Investment opportunity in MMR coastal belt',
      'Exclusive gated community'
    ],
    description: 'Experience the elegance of French Riviera living in Alibaug. Chateau de Alibaug offers premium villa plots with world-class amenities, perfect for those seeking a luxurious coastal retreat near Mumbai.'
  },
  {
    id: 'mission-blue-zone-mumbai',
    name: 'Mission Blue Zone',
    tagline: 'Mumbai - Healthier. Happier. Livelier.',
    location: 'Near Mumbai Metropolitan Region',
    type: 'Wellness-Focused Residential',
    status: 'Pre-Launch',
    pricing: {
      from: 'Coming Soon',
      note: 'Pre-opportunity document'
    },
    size: 'Residential plots & homes',
    image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c',
    featured: false,
    highlights: [
      'Inspired by global Blue Zones (Okinawa, Sardinia, Costa Rica)',
      'Focus on longevity and holistic well-being',
      'Walkable, car-lite urban planning',
      'Green buildings and sky parks',
      'Strong community bonds',
      'Plant-based dining options',
      'Wellness through urban innovation'
    ],
    description: 'A revolutionary wellness-focused development near Mumbai, reverse-engineering the lifestyle of the world\'s Blue Zones where people live longer, healthier lives.'
  },
  {
    id: 'chateau-de-alibaug-villaplex',
    name: 'Château de Alibaug VillaPlex',
    tagline: "Alibaug's New Gold Standard",
    location: 'Alibaug, Maharashtra',
    type: '4BHK Serviced VillaPlexes',
    status: 'Pre-Market',
    pricing: {
      from: 'Price on Request',
      note: 'Garden & Terrace formats'
    },
    size: '4BHK duplex VillaPlexes',
    image: 'https://images.unsplash.com/photo-1778910554261-837b19e25c26?crop=entropy&cs=srgb&fm=jpg&q=85',
    featured: false,
    highlights: [
      'Less than 20 minutes from Mandwa Jetty',
      'Garden VillaPlex with private garden and plunge pool',
      'Terrace VillaPlex with pool, alfresco dining, and 360° views',
      'Fully serviced by Miros Hotels & Resorts',
      'Personalized concierge, housekeeping, wellness, dining, and pet services',
      'Villa lifestyle with hospitality-grade management',
      'Strong rental potential and long-term resale appeal'
    ],
    description: 'A limited pre-market collection of lavish, fully serviced 4BHK duplex VillaPlexes in Alibaug. Choose Garden or Terrace formats with private leisure spaces, Miros hospitality, and a lock-and-leave ownership experience near Mandwa Jetty.'
  }
];
